import axios from "axios";
import BASEURL from "../Utils/Baseurl";
import { ApolloClient, InMemoryCache } from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';
import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";
 const uploadLink = createUploadLink({ uri: BASEURL });
  const client = new ApolloClient({
    link: uploadLink,
    cache: new InMemoryCache(),
  });
export const fetchData = async (query) => {
  try {
    const response = await axios.post(
      BASEURL,
      { 
        query : query

      },
      { headers: { "Content-Type": "application/json" } }
    );

    return response.data
  } catch (error) {
    console.error("API Fetch Error:", error);
    return [];
  }
};

export const CreateData = async (query, data) => {
  try {
    const response = await axios.post(
      BASEURL,
      {
        query: query,
        variables: data, 
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("API call error:", error);
    throw error; 
  }
};

export const GetIDData = async(query,id)=>{
   try {

    const response = await axios.post(
      BASEURL,
      {
        query,
        variables: { id },
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
      
    );
    return response.data;
   } catch (error) {
    console.error("API call error:", error);
    throw error; 
   }
}

export const UpdateData = async (query, data) => {
  try {
    const response = await axios.post(
      BASEURL,
      {
        query: query,
        variables: data, 
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("API call error:", error);
    throw error; 
  }
};

export const DeleteData = async(query,id)=>{
  try {

   const response = await axios.post(
     BASEURL,
     {
       query,
       variables: { id },
     },
     {
       headers: {
         "Content-Type": "application/json",
       },
     }
     
   );
   return response.data;
  } catch (error) {
   console.error("API call error:", error);
   throw error; 
  }
}


export const FileUpload = async (query, data) => {
  try {
    const response = await client.mutate(
      BASEURL,
      {
        mutation: query,
        variables: data, 
      },
    );

    return response.data;
  } catch (error) {
    loadDevMessages();
    loadErrorMessages();
    console.error("API call error:", error);
    throw error; 
  }
};
